module.exports = __webpack_public_path__ + "static/visual_7_do-77c65c46b72172f3fe92a5bb3545eb27.png";